import * as React from "react";
import * as main from "../../main.module.scss";
import * as decide from "./style.module.scss";
export const Decide = () => {
  return (
    <section className={decide.decide} id={"decide"}>
      <div className="container">
        <h2 className={main.title}>Сегодня <span className={main.violet}>вы решаете</span><br/> кем ваш ребенок<br/> будет завтра</h2>
        <a href="#gifts">
          <ul className={decide.mainList}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/decide-1.png" alt=""/>
              <div className={decide.info}>
                <h3 className={decide.strat}>Родитель стратег</h3>
                <ul className={decide.innerList}>
                  <li>Дает удочку, а не рыбу</li>
                  <li>Воспитывает успешную личность</li>
                  <li>Зарождает интерес к учебе</li>
                  <li>Помогает найти решение</li>
                  <li>Прививает навык обучения</li>
                </ul>
              </div>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/decide-2.png" alt=""/>
              <div className={decide.info}>
                <h3 className={decide.control}>Родитель контроллер</h3>
                <ul className={decide.innerList}>
                  <li>Ругает за ошибки, стыдит за двойки</li>
                  <li>Лишает ребенка самостоятельности</li>
                  <li>Запугивает и зарождает сомнения</li>
                  <li>Делает Д/З за ребенка чтобы не было двойки</li>
                  <li>Прививает желание «соответствовать»</li>
                </ul>
              </div>
            </li>
          </ul>
          <div className={decide.learn}>
            <h3>За 5 дней вы&nbsp;узнаете</h3>
            <p>Как <span>заставить</span> ребенка делать ДЗ и учиться самостоятельно на хорошо и отлично</p>
            <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/decide-block.png" alt=""/>
          </div>
        </a>
      </div>
    </section>
  );
};
